export const getRandomInt = (min: number, max: number) =>
  Math.random() * (max - min) + min;

// 1. GENERATE: Create a cryptographically secure random string
export const generateSecureString = () => {
  const array = new Uint32Array(8); // 32 bytes of entropy
  window.crypto.getRandomValues(array);
  // Convert to hex string
  return Array.from(array, dec => dec.toString(16).padStart(2, '0')).join('');
};

// PKCE (Proof Key for Code Exchange) helpers for OAuth 2.0

/**
 * Generates a code verifier for PKCE (43-128 character random string)
 * https://datatracker.ietf.org/doc/html/rfc7636
 * Uses URL-safe base64 encoding without padding
 */
export const generateCodeVerifier = (): string => {
  const array = new Uint8Array(32); // 32 bytes = 256 bits of entropy
  window.crypto.getRandomValues(array);
  // Convert to base64url (URL-safe base64 without padding)
  return base64UrlEncode(array);
};

/**
 * Creates a code challenge from a code verifier using SHA-256
 * https://datatracker.ietf.org/doc/html/rfc7636
 * @param verifier - The code verifier string
 * @returns Promise resolving to the base64url-encoded SHA-256 hash
 */
export const generateCodeChallenge = async (verifier: string): Promise<string> => {
  const encoder = new TextEncoder();
  const data = encoder.encode(verifier);
  const hash = await window.crypto.subtle.digest('SHA-256', data);
  return base64UrlEncode(new Uint8Array(hash));
};

/**
 * Encodes a byte array to base64url format (URL-safe base64 without padding)
 */
const base64UrlEncode = (array: Uint8Array): string => {
  // Convert to base64
  const base64 = btoa(String.fromCharCode(...array));
  // Convert to base64url: replace +/= with -_
  return base64
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=/g, '');
};
